import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6ee41ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ng-extend nge-tut-resume",
  role: "dialog",
  "aria-label": "Resume tutorial"
}
const _hoisted_2 = { class: "nge-tut-resume-text" }
const _hoisted_3 = { class: "nge-tut-resume-step" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (!$setup.quietOnLoad)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($setup.needsResumePrompt)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(" You're partway through "),
                _createElementVNode("strong", null, _toDisplayString($setup.resumeName), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_3, "step " + _toDisplayString(($setup.activeStep?.index ?? 0) + 1) + " of " + _toDisplayString($setup.steps.length), 1 /* TEXT */)
              ]),
              _createElementVNode("div", { class: "nge-tut-resume-actions" }, [
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-hud-btn--arrow nge-tut-resume-go",
                  onClick: $setup.continueTutorial
                }, "Continue"),
                _createElementVNode("button", {
                  class: "nge-hud-btn nge-hud-btn--quiet nge-tut-resume-exit",
                  onClick: $setup.exitFromPrompt
                }, "Exit tutorial")
              ])
            ]))
          : ($setup.activeStep)
            ? (_openBlock(), _createBlock($setup["TutorialStep"], {
                key: $setup.activeStep.index,
                step: $setup.activeStep.step,
                first: $setup.activeStep.first,
                last: $setup.activeStep.last,
                stepIndex: $setup.activeStep.shownIndex,
                totalSteps: $setup.activeStep.shownTotal,
                partLabel: $setup.activeStep.partLabel,
                boxIndex: $setup.activeStep.index,
                onNext: $setup.next,
                class: _normalizeClass({ 'nge-tut-under-card': $setup.testCardUp }),
                onBack: $setup.back,
                onExitIntro: $setup.exitIntro
              }, null, 8 /* PROPS */, ["step", "first", "last", "stepIndex", "totalSteps", "partLabel", "boxIndex", "class"]))
            : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}